import { ANALYTICS_KEYS, Block, EventSources } from '@/types';
import { useAnalyticContext } from '@/modules/analytic/providers/AnalyticProvider';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

interface TrackViewBlockProps {
  block: Block;
}

export const useTrackViewBlock = () => {
  const { track } = useAnalyticContext();
  const { asPath } = useRouter();

  const trackViewBlock = useCallback(
    ({ block }: TrackViewBlockProps) => {
      const source = asPath.split('/')[1] || EventSources.Category;

      track(ANALYTICS_KEYS.BROWSE_VIEW_BLOCK, {
        blockUUID: block.UUID,
        block_title: block.title,
        block_type: block.type,
        block_format: block.format,
        source_home: source,
      });
    },
    [asPath, track]
  );

  return { trackViewBlock };
};
